export default __webpack_public_path__ + "static/media/Brian_Hayes_Resume.37e72e9a.pdf";